import { render, staticRenderFns } from "./AltbestaendeReiter.vue?vue&type=template&id=efa8f182&"
import script from "./AltbestaendeReiter.vue?vue&type=script&lang=js&"
export * from "./AltbestaendeReiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports